<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view v-if="isChrome"></router-view>
			<div v-else class="brower_error">
				<span>当前不是谷歌浏览器，请使用谷歌浏览器访问！！！</span>
			</div>
		</transition>
		<!-- 用于版本更新进度展示 -->
		<el-dialog
			title="版本更新"
			:visible.sync="centerDialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			width="30%"
			center>
			<el-progress :text-inside="true" :stroke-width="24" :percentage="percentage" status="success"></el-progress>
			<span slot="footer" class="dialog-footer" v-if="state==4">
				<el-button size="small" type="primary" @click="btnHandler">{{'退出并安装'}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getBrowerInfo } from "service/utils";
export default {
    name: "app",
    data() {
        return {
            centerDialogVisible: false,
            percentage: 0,
            state: 0,
            ipc: null
        };
    },
    components: {},
    computed: {
        isChrome() {
            let { browserType } = getBrowerInfo();
            return browserType == "谷歌" || true;
        }
    },
    mounted: function() {
        if (window.require) {
            this.ipc = window.require("electron").ipcRenderer;
            //this.ipc.send("checkForUpdate");
            this.ipc.on("message", (event, data) => {
                const { state, msg } = data;
                switch (data.state) {
                    case 1:
                        this.$confirm("发现新的版本，请点击下载", "更新提示", {
                            confirmButtonText: "下 载",
                            showClose: false,
                            showCancelButton: false,
                            closeOnPressEscape: false,
                            closeOnClickModal: false,
                            center: true,
                            type: "warning"
                        }).then(() => {
                            this.centerDialogVisible = true;
                            setTimeout(() => {
                                this.ipc.send("downloadNow");
                            }, 5000);
                        });
                        break;
                    case 3:
                        this.percentage = msg.percent;
                        break;
                    case 4:
                        this.state = state;
                        break;
                    default:
                }
            });
            this.ipc.send("close-loading-window", {
                isClose: true
            });
        }
    },
    methods: {
        btnHandler() {
            let state = this.state;
            if (state == 4) {
                this.ipc.send("confirm-update");
            }
        }
    }
};
</script>

<style lang="scss" type="text/css">
body {
    margin: 0px;
    padding: 0px;
    font-family: Helvetica Neue, Helvetica, "Microsoft YaHei", "PingFang SC",
        "Hiragino Sans GB", "SimSun", sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    .el-button--primary {
        background-color: #5e89ff;
        border-color: #5e89ff;
    }
    .el-button--info {
        background-color: #b3b7c2;
        border-color: #b3b7c2;
    }
    .el-button {
        border-radius: 2px;
    }
}

#app {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    .brower_error {
        text-align: center;
        display: table;
        height: 100%;
        width: 100%;
        font-size: 2em;
        span {
            display: table-cell;
            vertical-align: middle;
        }
    }
}

.el-submenu [class^="fa"] {
    vertical-align: baseline;
    margin-right: 10px;
}

.el-menu-item [class^="fa"] {
    vertical-align: baseline;
    margin-right: 10px;
}

.toolbar {
    background: #f2f2f2;
    padding: 10px;
    //border:1px solid #dfe6ec;
    margin: 10px 0px;
    .el-form-item {
        margin-bottom: 10px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue